import ErrorNotification from '../ErrorNotification';

const InputSelect = ({ id, name, label, value, error, onChange }) => {
  const t = (k) => (window.accessI18n?.[k] ?? k);

  return (
    <>
      <label htmlFor={id}>{label}</label>
      <select
        id={id}
        name={name}
        className={error && value === "" ? "border-danger" : "border-none"}
        onChange={onChange}
        defaultValue=""
      >
        <option value="" disabled>{t("Please choose an option")}</option>
        <option value="I'm an agency or a freelancer">{t("Yes, I'm an agency or a freelancer")}</option>
        <option value="I'm a website owner">{t("No, I'm a website owner")}</option>
        <option value="None of the above">{t("None of the above")}</option>
      </select>
      {/* <input
        id={id}
        name={name}
        className={error && value === "" ? "border-danger" : "border-none"}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      /> */}
      {error && <ErrorNotification message={error} className="text-secondary" />}
    </>
  );
};

export default InputSelect;